import React, { Fragment, useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContext";
import { Button, LoginBox, SiteContext, Text } from "ywana-core8";
import "./page.css";

/**
 * Login Page
 */
const Page = () => {

    const params = new URLSearchParams(window.location.search);
    const site = useContext(SiteContext);
    const context = useContext(AppContext);
    const [error, setError] = useState();

    const landingPage = {
        "admin": "PLANS",
        "photographer": "PHOTOSHOOTS",
        "planner": "PLAN",
        "isend1": "ISEND",
        "isend2": "ISEND",
        "isend3": "ISEND"
    };

    useEffect(() => {
        //login("admin", "12345678")
    }, [])

    async function login(email, password) {
        try {
            setError("");
            const me = await context.login(email, password);
            site.goto(landingPage[me.role]);
            site.setBreadcrumb(<Text use="headline5"><strong>STUDIOS</strong></Text>)
        } catch (error) {
            console.log(error)
            setError("Usuario/Password no Encontrado");
        }
    }

    async function forget() {
        const email = window.prompt("Te vamos a enviar una nueva password. Indica tu correo electrónico:");
        await context.forget(email);
        site.notify({
            title: "Renovar Contraseña!",
            body: "Recibirás un correo con tu nueva contraseña...",
            icon: "email",
        });
    }

    return (
        <Fragment>
            <main className="login-page">
                <div>
                    {process.env.REACT_APP_VERSION}
                </div>
        
                <LoginBox title={`Ywana Workspace`} onOK={login} />
                {error ? <div className="login-error">{error}</div> : ""}
                {params.has('showUsers') ? (
                    <div className="users">
                        <Button outlined label="ADMIN" action={() => login("admin", "12345678")} />
                    </div>
                ) : ''}
            </main>
        </Fragment>
    );
};

export default Page;
